<template>
  <div class="w-full h-full d-flex flex-column pa-3">
    <OAlert warning v-if="!profiles.length">
      Este usuário não possui perfis, e não poderá fazer login no Dashboard.
    </OAlert>

    <v-list class="w-full py-0 overflow-y-auto">
      <OListItem v-for="item in profiles" :key="item.id" v-bind="item" />
    </v-list>

    <div class="pa-3 mt-8">
      <v-btn large color="primary" @click="edit">Editar</v-btn>
    </div>

    <ODialog ref="editDialog" :maxWidth="600">
      <v-card>
        <ODialogBar title="Selecionar Perfis" @close="dismiss" />
        <v-card-text class="pa-0">
          <OAutocompleteMultiple
            label="Buscar perfis..."
            :filter.sync="txtFilter"
            :filteredItems="filteredItems"
            v-model="clonedValues"
            innerListClass="h-300 overflow-y-scroll"
          />
        </v-card-text>
        <ODialogButtons
          class="pa-6"
          @apply="apply"
          @cancel="dismiss"
          txtApply="Salvar"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import OAutocompleteMultiple from 'oderon-vue/cpts/forms/OAutocompleteMultiple.vue'
import OListItem from 'oderon-vue/cpts/lists/OListItem.vue'
import { OrgApi } from '@/models/index.js'
import utils from 'oderon-commons/src/utils.js'

const ROOT_CHIP = { cssClass: 'error', text: 'root' }

function toItem(profile, leftIcon) {
  return {
    id: profile.id,
    leftIcon,
    title: profile.label,
    subtitle: profile.description,
    rightChip: profile.isRoot ? ROOT_CHIP : null
  }
}

export default {
  components: { OListItem, OAutocompleteMultiple },
  computed: {
    profiles() {
      if (this.value == null) return []
      return this.value.profiles.map((x) =>
        toItem(x, 'mdi-badge-account-horizontal')
      )
    },

    filteredItems() {
      return this.allProfiles.filter((x) => {
        return utils.matchAnyLike(this.txtFilter, x.title, x.subtitle)
      })
    }
  },
  props: {
    value: { required: true }
  },
  data() {
    return {
      clonedValues: [],
      txtFilter: null,
      allProfiles: []
    }
  },
  watch: {
    value: {
      handler() {
        this.clonedValues = (this.value.profiles || []).map((x) => toItem(x))
        this.fetchItems()
      },
      immediate: true
    }
  },
  methods: {
    async fetchItems() {
      let items = await new OrgApi(this.value.orgId).get('profiles')
      this.allProfiles = items.map((x) => toItem(x))
    },
    edit() {
      this.$refs.editDialog.$open()
    },
    dismiss() {
      this.$refs.editDialog.$dismiss()
    },
    apply() {
      this.dismiss()
      this.$rootLoading(async () => {
        let fetcher = new OrgApi(this.value.orgId)
        let old = await fetcher.get(`users/${this.value.id}`)
        old.profileIds = this.clonedValues.map((x) => x.id)
        await fetcher.put(`users/${this.value.id}`, old)
        this.$snack('Salvo com sucesso')
        this.$emit('reload')
      })
    }
  }
}
</script>

<style></style>
